<template >
  <div>
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'transferordermanagement',
  components: {
  }
}
</script>
<style lang="less" scoped>
</style>
